import back from '../../../public/back_black.svg';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';

interface Props {
  title: string;
  backable?: boolean;
  extra?: ReactNode;
}

const PageTitle = ({ title, backable, extra }: Props) => {
  const router = useRouter();

  const onBack = () => {
    router.back();
  };

  return (
    <div className="mb-4 flex items-center">
      {backable && (
        <a onClick={onBack} className="flex hover:cursor-pointer">
          <Image src={back} width="24" height="24" alt="" />
        </a>
      )}
      <h2 className="text-2xl">{title}</h2>
      {extra && extra}
    </div>
  );
};

export { PageTitle };
